/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as EmbedDefs from './defs.defs.js'

const $nsid = 'app.bsky.embed.video'

export { $nsid }

type Main = {
  $type?: 'app.bsky.embed.video'

  /**
   * The mp4 video file. May be up to 100mb, formerly limited to 50mb.
   */
  video: l.BlobRef
  captions?: Caption[]

  /**
   * Alt text description of the video, for accessibility.
   */
  alt?: string
  aspectRatio?: EmbedDefs.AspectRatio

  /**
   * A hint to the client about how to present the video.
   */
  presentation?: 'default' | 'gif' | l.UnknownString
}

export type { Main }

const main = l.typedObject<Main>(
  $nsid,
  'main',
  l.object({
    video: l.blob({ accept: ['video/mp4'], maxSize: 100000000 }),
    captions: l.optional(
      l.array(l.ref<Caption>((() => caption) as any), { maxLength: 20 }),
    ),
    alt: l.optional(l.string({ maxGraphemes: 1000, maxLength: 10000 })),
    aspectRatio: l.optional(
      l.ref<EmbedDefs.AspectRatio>((() => EmbedDefs.aspectRatio) as any),
    ),
    presentation: l.optional(l.string<{ knownValues: ['default', 'gif'] }>()),
  }),
)

export { main }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main),
  $build = /*#__PURE__*/ main.build.bind(main),
  $type = /*#__PURE__*/ main.$type
export const $assert = /*#__PURE__*/ main.assert.bind(main),
  $check = /*#__PURE__*/ main.check.bind(main),
  $cast = /*#__PURE__*/ main.cast.bind(main),
  $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main),
  $matches = /*#__PURE__*/ main.matches.bind(main),
  $parse = /*#__PURE__*/ main.parse.bind(main),
  $safeParse = /*#__PURE__*/ main.safeParse.bind(main),
  $validate = /*#__PURE__*/ main.validate.bind(main),
  $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

type Caption = {
  $type?: 'app.bsky.embed.video#caption'
  lang: l.LanguageString
  file: l.BlobRef
}

export type { Caption }

const caption = l.typedObject<Caption>(
  $nsid,
  'caption',
  l.object({
    lang: l.string({ format: 'language' }),
    file: l.blob({ accept: ['text/vtt'], maxSize: 20000 }),
  }),
)

export { caption }

type View = {
  $type?: 'app.bsky.embed.video#view'
  cid: l.CidString
  playlist: l.UriString
  thumbnail?: l.UriString
  alt?: string
  aspectRatio?: EmbedDefs.AspectRatio

  /**
   * A hint to the client about how to present the video.
   */
  presentation?: 'default' | 'gif' | l.UnknownString
}

export type { View }

const view = l.typedObject<View>(
  $nsid,
  'view',
  l.object({
    cid: l.string({ format: 'cid' }),
    playlist: l.string({ format: 'uri' }),
    thumbnail: l.optional(l.string({ format: 'uri' })),
    alt: l.optional(l.string({ maxGraphemes: 1000, maxLength: 10000 })),
    aspectRatio: l.optional(
      l.ref<EmbedDefs.AspectRatio>((() => EmbedDefs.aspectRatio) as any),
    ),
    presentation: l.optional(l.string<{ knownValues: ['default', 'gif'] }>()),
  }),
)

export { view }
